import { render, staticRenderFns } from "./LayerColorCostCalculation.vue?vue&type=template&id=4d6e9f82"
import script from "./LayerColorCostCalculation.vue?vue&type=script&lang=js"
export * from "./LayerColorCostCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports